var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.styles.slice().reverse()),function(css,key){return _c('link',{key:key,attrs:{"rel":"stylesheet","href":css}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }